import { render, staticRenderFns } from "./land-filter.vue?vue&type=template&id=2f9af237"
import script from "./land-filter.vue?vue&type=script&lang=js"
export * from "./land-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports